import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import swal from 'sweetalert2';        

@Component({
  selector: 'app-atenderticket',
  templateUrl: './atenderticket.component.html',
  styleUrls: ['./atenderticket.component.scss']
})
export class AtenderticketComponent implements OnInit {

  constructor( public authService: AuthService,
    public router: Router) { }
  ngOnInit() {    
    this.ls_modulos();
    this.garoce_soporte();
    this.ls_ticket();
    this.id_usuario=Number(localStorage.getItem("usuario"))
  }
  bndmnugral=true;
  oculta_menu(){
    console.log("-");
    if(this.bndmnugral==true){
      this.bndmnugral=false;
    }else{
      this.bndmnugral=true;
    }
    console.log(this.bndmnugral);
  }
  id_usuario=0;
  asignadosami(){
    console.log("a mi")
    this.ticket=[];
    console.log(this.tiket_aux)
    console.log(this.id_usuario)
    for(var i=0;i<this.tiket_aux.length;i++){
      if(this.tiket_aux[i].asignado_a==this.id_usuario){
        this.ticket.push(this.tiket_aux[i]);
      }
    }    
  }

  todos(){
    this.ticket=this.tiket_aux;

  }
  ticket=[];
  modulos=[];
  loading;
  ls_modulos(){
    let postData={
    };    
    this.loading=true;    
    this.authService.service("/api/permisos",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.modulos=data;
        //console.log(data)
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  }
  des_ticket="";
  bndEditticket=false;
  id_modulo=0;
  id_ticket=0;
  estatus="";
  editar_t(itm){
    this.id_ticket=itm.id; 
    this.id_modulo=itm.id_modulo;
    this.asignado_a=itm.asignado_a;
    this.estatus=itm.estatus;
    this.bndEditticket=true;
  }
  vdet_ticket(itm){
    this.id_ticket=itm.id;
    let postData={
      id_ticket:itm.id
    }
    this.authService.service("/api/get_detticket",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.det_ticket=data;        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  }
  txt_detticket="";
  gdadet_ticket(){
    let data={
      id_ticket:this.id_ticket,
      descripcion:this.txt_detticket,
      id_usuario:localStorage.getItem("usuario"),
    };
    //console.log(data);
    this.authService.service("/api/gda_detticket",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.vdet_ticket({id:this.id_ticket});
        this.txt_detticket="";
        swal.fire('ok', '', 'success');
      },
      error => {
        swal.fire('¡API incorrecta..! gdadet_ticket', '', 'error');
        //console.log(error);
      });
  }
  det_ticket=[];
  asignado_a=0;
  upd_ticket(){
    let data={
      id:this.id_ticket,
      id_modulo:this.id_modulo,
      estatus:this.estatus,
      asignado_a:this.asignado_a,
      id_usuario:localStorage.getItem("usuario"),
    };
    //console.log(data);
    this.authService.service("/api/upd_ticket_atiende",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ls_ticket();
        swal.fire('ok', '', 'success');
      },
      error => {
        //console.log(error);
      });
  }
  nvo_ticket(){
    this.bndEditticket=false;
    this.des_ticket="";
    this.id_modulo=0;
  }
  soporte=[];
  garoce_soporte(){
    this.soporte=[]
    let data={

    };
    this.authService.service("/api/get_equipo_garoce",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.soporte= res;
      },
      error => {
        console.log(error);
      });

  }
  org_;
  gda_ticket(){}
  tiket_aux=[];
  ls_ticket(){
    this.ticket=[]
    let data={
      id_usuario:localStorage.getItem("usuario"),
      id_cliente:localStorage.getItem("id_cliente")

    };
    console.log(data)
    this.authService.service("/api/get_ticket_abiertos",data).then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);
        this.ticket= res;
        this.tiket_aux=res;
      },
      error => {
        console.log(error);
      });

  }
}
